import Avatar from '@mui/joy/Avatar';
import type { ReactElement } from 'react';

import { getLightChartColor } from '../../../theme/colors';
import { hashcode } from '../../hashcode.utils';
import { useFinalColorScheme } from '../../../technical/useFinalColorScheme.ts';
import type { SxProps } from '@mui/system';
import { type IconVariant, iconVariantToPx } from '../../market/asset/cryptocurrencies/CryptocurrenciesData.tsx';
import { mergeSx } from 'components/sx.utils.ts';

const UnknownIcon = (props: {
  text: string | null | undefined;
  sx?: SxProps;
  size: IconVariant;
}): ReactElement => {
  const hash = hashcode(props.text);
  const firstLetter = props.text?.at(0)?.toUpperCase() ?? '';
  const colorScheme = useFinalColorScheme();

  const iconSize = iconVariantToPx(props.size);
  const style = {
    height: iconSize,
    width: iconSize,
    fontSize: iconSize * 0.6, // empyrical value
    textTransform: 'none',
    textDecoration: 'none',
  } as const;

  return (
    <Avatar
      sx={mergeSx(
        {
          background: getLightChartColor(colorScheme, hash),
          color: 'var(--joy-palette-neutral-500)',
        },
        style,
        props.sx
      )}
    >
      {firstLetter}
    </Avatar>
  );
};

export default UnknownIcon;
